module.exports = __webpack_public_path__ + "videos/tests-and-surveys.f6237fd.webm";